import { Auth } from "app/components/auth/auth.component";
import { usePlayerContext } from "app/context/player.context";
import { useGoBackHistory } from "app/hooks/go-back.hook";
import { useTranslate } from "app/hooks/lang";
import { selectUserState } from "app/store/slices/user";
import { useAppSelector } from "app/store/store";
import useMetaDescription from "app/utils/getMetaDescription";
import { NextPage } from "next";
import Head from "next/head";
import { useRouter } from "next/router";
import qs from "qs";
import { useEffect, useMemo, useState } from "react";
import { useCallback } from "react";
import styles from "./log-in.module.scss";

const LogIn: NextPage = () => {
  const router = useRouter();
  const { openplayer, redirect, ...rest } = router.query;
  const { session } = useAppSelector(selectUserState);
  const { setFullscreenPlayerInitialyOpen } = usePlayerContext();
  const [queryParamsProcessed, setQueryParamsProcessed] = useState(false);
  const [openPlayerAfterLogin, setOpenPlayerAfterLogin] = useState(false);
  const [redirectTo, setRedirectTo] = useState<string | null>(null);
  
  useEffect(() => {
    if (router.isReady) {
      if (openplayer) {
        setOpenPlayerAfterLogin(true);
      }
      if (redirect) {
        setRedirectTo(redirect as string);
      }
      setQueryParamsProcessed(true);
    }
  }, [openplayer, redirect, router.isReady]);
  useEffect(() => {
    if (queryParamsProcessed) {
      router.replace({ pathname: router.pathname, query: rest }, undefined, {
        scroll: false,
      });

      if (session?.user) {
        onSuccess(!!openplayer, redirect as string | null);
      }
    }
  }, [queryParamsProcessed]);
  const t = useTranslate();
  useGoBackHistory("LOGIN");
  const getMetaDescription = useMetaDescription();
  
  const onSuccess = (openPlayer: boolean, redirect: string | null) => {
    if (openPlayer) {
      setFullscreenPlayerInitialyOpen(true);
    }
    if (redirect) {
      const targetSplit = redirect.split("?");
      if (targetSplit.length > 1) {
        router.push({
          pathname: targetSplit[0],
          query: { ...(qs.parse(targetSplit[1]) as Record<string, any>) },
        });
      } else {
        router.push(redirect);
      }
    } else {
      if (typeof window !== 'undefined' && window?.history?.length <= 2) {
        // 2 beacuse of language redirect
        router.push('/');
      } else {
        router.back();
      }
    }
  };
  const onSuccessCallback = useCallback(() => {
    onSuccess(openPlayerAfterLogin, redirectTo);
  }, [openPlayerAfterLogin, redirectTo]);
  const onCloseCallback = useCallback(() => {
    router.back();
    if (openPlayerAfterLogin) {
      setFullscreenPlayerInitialyOpen(true);
    }
  }, [openPlayerAfterLogin]);

  return (
    <>
      <div className={styles.container}>
        <Head>
          <title>{t("log-in")} - Radioline</title>
          {getMetaDescription(t("settings.meta-description"))}
        </Head>
        <Auth onClose={onCloseCallback} onSuccess={onSuccessCallback} />
      </div>
    </>
  );
};

export default LogIn;
